function scrollTo(e: React.MouseEvent<HTMLAnchorElement>, id: string) {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

export default function Hero() {
  return (
    <section className="bg-primary relative overflow-hidden">
      {/* Subtle grid background */}
      <div
        className="absolute inset-[-60px] pointer-events-none"
        style={{
          backgroundImage: `
            repeating-linear-gradient(
              to bottom,
              transparent,
              transparent 59px,
              rgba(200, 180, 150, 0.06) 59px,
              rgba(200, 180, 150, 0.06) 60px
            ),
            repeating-linear-gradient(
              to right,
              transparent,
              transparent 59px,
              rgba(200, 180, 150, 0.06) 59px,
              rgba(200, 180, 150, 0.06) 60px
            )
          `,
          backgroundSize: '60px 60px',
          animation: 'grid-scroll 25s linear infinite',
        }}
      />

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 40%, hsl(var(--primary)) 80%)',
        }}
      />

      <style>{`
        @keyframes grid-scroll {
          0% { transform: translate(0, 0); }
          100% { transform: translate(-60px, -60px); }
        }
      `}</style>

      <div className="max-w-6xl mx-auto px-6 py-24 md:py-36 relative z-10 text-center">
        <h1 className="font-bodoni text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium text-primary-foreground leading-[1.1] tracking-tight md:whitespace-nowrap">
          You get one shot.{' '}
          <em className="italic text-primary-accent-400 font-normal">Take it twice.</em>
        </h1>
        <p className="mt-8 text-lg md:text-xl text-primary-foreground/80 max-w-4xl mx-auto leading-[1.7] font-normal">
          AI voice interviews tuned to every company's real style,{' '}
          <span className="text-primary-accent-400">Amazon, Google, Infosys, and more</span>. Rehearse the exact interview you're walking into, with feedback on{' '}
          <span className="text-primary-accent-400">what they'll actually judge</span>.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#try-interview"
            onClick={(e) => scrollTo(e, 'try-interview')}
            className="bg-primary-accent-500 text-primary font-semibold px-8 py-3 rounded-full text-lg hover:bg-primary-accent-400 transition-colors"
          >
            Try a Mock Interview
          </a>
          <a
            href="#book-demo"
            onClick={(e) => scrollTo(e, 'book-demo')}
            className="border border-primary-accent-500 text-primary-accent-500 font-semibold px-8 py-3 rounded-full text-lg hover:bg-primary-accent-500/10 transition-colors"
          >
            Book a 15-min Call
          </a>
        </div>
      </div>
    </section>
  );
}
